import { render, staticRenderFns } from "./ErrorNextSteps.vue?vue&type=template&id=efc25b06&"
import script from "./ErrorNextSteps.vue?vue&type=script&lang=ts&"
export * from "./ErrorNextSteps.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorNextSteps.vue?vue&type=style&index=0&id=efc25b06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports